import { useContext, useEffect } from 'react';
import { subscribeToPush } from 'Infrastructure/Service/PushService'
import { useSelector } from 'react-redux'
import { ProjectContext } from 'Application/Context/ProjectContext'
import { useInstallPrompt } from 'Application/Hooks/useInstallPrompt'
import { useResize } from 'Application/Hooks/useResize'
import { useAnalyticsHeartbeat } from 'Application/Hooks/useAnalyticsHeartbeat'
import { initActivityTracking } from 'Infrastructure/Service/AnalyticsService'
import { Modal } from 'Ui/Components/Modal'
import { locale, ihm_viewer__dictionary } from 'Application/i18n/i18nViewer'

import { Header } from 'Ui/Header'
import { Main } from 'Ui/Main.js'
import { Footer } from 'Ui/Footer'
import { Logo } from 'Ui/Components/Logo'
import { Validation } from 'Ui/Validation'


/*****************************************************************
 * App show Project Data
 * Logo reste en overlay pendant toute l'initialisation
 * et se masque automatiquement quand INIT_PHASES.COMPLETE est atteint
 * ***************************************************************/

export default function App () {

  const project = useContext( ProjectContext )
  const { isOpen, handleInstall, handleClose, isIOS } = useInstallPrompt();
  const isPortrait = useSelector(state => state.LayoutReducer.global?.isPortrait ?? false)

  useResize()
  useAnalyticsHeartbeat()
  initActivityTracking()

  useEffect(() => {
    const handlePush = () => {
        if (typeof window !== 'undefined' && 'Notification' in window) {
            if (Notification.permission === 'granted') {
                subscribeToPush();
            }
        }
    };
    handlePush();

    const requestNotificationPermission = () => {
        if (typeof window !== 'undefined' && 'Notification' in window) {
            if (Notification.permission === 'default') {
                Notification.requestPermission().then(permission => {
                    console.log('[Notification] Permission state changed:', permission);
                    if (permission === 'granted') {
                        subscribeToPush();
                    }
                });
            }
        }
    };
    document.addEventListener('click', requestNotificationPermission, { once: true });
    
    return () => {
        document.removeEventListener('click', requestNotificationPermission);
    }
  }, [])

  const t = (key) => ihm_viewer__dictionary[key]?.[locale()] || '';

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title={t('PWA_INSTALL_TITLE')}
        size="small"
      >
        {isIOS ? (
          <>
            <p style={{ margin: '0 0 16px 0', lineHeight: 1.4 }}>
              {t('PWA_INSTALL_IOS_TEXT')}
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button className="modal-btn modal-btn-cancel" onClick={handleClose}>
                OK
              </button>
            </div>
          </>
        ) : (
          <>
            <p style={{ margin: '0 0 16px 0', lineHeight: 1.4 }}>
              {t('PWA_INSTALL_ANDROID_TEXT')}
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button className="modal-btn modal-btn-cancel" onClick={handleClose}>
                {t('PWA_INSTALL_LATER')}
              </button>
              <button className="modal-btn modal-btn-primary" onClick={handleInstall}>
                {t('PWA_INSTALL_NOW')}
              </button>
            </div>
          </>
        )}
      </Modal>
      <div className="App">
        <Logo />
        {project.type &&
          {
            'consultation': <>{!isPortrait && <Header project={project} isPortrait={isPortrait}/>}<Main project={project} isPortrait={isPortrait} /><Footer isPortrait={isPortrait}/></>,
            'validation': <Validation project={project} />
          }[ project.type ]
        }
      </div>
    </>
  )

}
